import { useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { backendClient } from "@/lib/backendClient";
import { useSessionStore } from "@/store/session";
import { parseContactResponse } from "../mappers/contact.parse";
import GET_CONTACT_QUERY from "../graphql/GetContact.graphql";

export function useContact() {
    const { dealId, email, setContact, setLoadingContact } = useSessionStore();

    const { data, loading } = useQuery<unknown>(GET_CONTACT_QUERY, {
        client: backendClient,
        variables: { input: { email, hubspotDealId: Number(dealId) } },
        skip: !dealId || !email,
    });

    const contact = useMemo(() => parseContactResponse(data), [data]);

    useEffect(() => {
        setLoadingContact(loading);
        if (contact) setContact(contact);
    }, [loading, contact, setLoadingContact, setContact]);
}
